import React, { useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Warehouse } from '../services/warehousesService';
import { ModernWarehouseList } from './ModernWarehouseList';
import { ModernWarehouseForm } from './ModernWarehouseForm';

export const ModernWarehouseManagement: React.FC = () => {
  const { translate } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [editingWarehouse, setEditingWarehouse] = useState<Warehouse | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const listRef = useRef<{ refresh: () => void }>(null);

  const handleCreateClick = () => {
    setEditingWarehouse(null);
    setFormOpen(true);
  };

  const handleEditClick = (warehouse: Warehouse) => {
    setEditingWarehouse(warehouse);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingWarehouse(null);
  };

  const handleFormSave = async (warehouse: Warehouse) => {
    setFormOpen(false);
    setEditingWarehouse(null);
    
    // Trigger refresh of the warehouse list after a delay to ensure API call completes
    setTimeout(() => {
      setRefreshKey((prev) => prev + 1);
    }, 1000);
  };

  return (
    <div className="container mx-auto p-6" data-testid="warehouse-management">
      <ModernWarehouseList
        refreshTrigger={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernWarehouseForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        warehouse={editingWarehouse}
      />
    </div>
  );
};

